var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.633,
    height: 14.438,
    viewBox: "0 0.085 12.633 14.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.316 7.304A3.61 3.61 0 1 0 6.317.085a3.61 3.61 0 0 0 0 7.219ZM5.028 8.657A5.027 5.027 0 0 0 0 13.685c0 .462.375.837.837.837h10.958a.838.838 0 0 0 .838-.837 5.027 5.027 0 0 0-5.028-5.028H5.028Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "user-solid"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.0d816b01f2059cb3aede52cdc16bab47.svg";
export { ForwardRef as ReactComponent };